import React from 'react';
import { withRouter } from 'react-router-dom';

import MobileBridge from '../../helpers/MobileBridge';
import MobileHeader from '../../components/MobileHeader';
import MobileListItem from '../../components/MobileListItem';

import DirectoryIcon from '../../assets/images/directory-icon-gray.svg';
import MyProfileIcon from '../../assets/images/user-circle.svg';
import SupportIcon from '../../assets/images/support.svg';
import SettingsIcon from '../../assets/images/settings-gear.svg';

import './MoreMenuWrapper.scss';
import '../MobileWrapper.scss';

export class MoreMenuWrapper extends React.Component {

  constructor(props) {
    super(props);

    this.menuItemData = [
      { name: 'Directory', icon: DirectoryIcon, onClick: (() => this.props.history.push('/mobile/directory')) },
      { name: 'My Profile', icon: MyProfileIcon, onClick: (() => this.props.history.push('/mobile/my-profile')) },
      { name: 'Support', icon: SupportIcon, onClick: (() => this.props.history.push('/mobile/support')) },
      { name: 'Settings', icon: SettingsIcon, onClick: (() => this.props.history.push('/mobile/settings')) },
    ];

    this.navigateBack = this.navigateBack.bind(this);
    this.openDirectory = this.openDirectory.bind(this);
  }

  componentDidMount() {
    delete localStorage.scrollPositionTasks;
    delete localStorage.scrollPositionCompletionStep;
    delete localStorage.scrollPosition;
    MobileBridge.initialize(this.props.history);
  }

  navigateBack() {
    MobileBridge.fireNativeEvent('native.navigateTo', {
      data: {
        notification_type: 'Back',
      },
    });
  }

  openDirectory() {
    MobileBridge.fireNativeEvent('native.navigateTo', {
      data: {
        notification_type: 'Directory',
      },
    });
  }

  render() {
    const menuItems = this.menuItemData.map(itemData => 
      <MobileListItem handleClick={itemData.onClick} key={itemData.name}>
        <span className='more-menu-item'>
          <img className='more-menu-item__icon' src={itemData.icon} alt={itemData.name}/>
          <span className='more-menu-item__name'>{itemData.name}</span>
        </span>
      </MobileListItem>
    );

    return (
      <div className="mobile-wrapper"> 
        <MobileHeader
          headerTitle={'More'}
          noBackButton={true}
        />
        <div className="more-wrapper content-wrapper">
          {menuItems}
        </div>
      </div>
    );
  }
}

export default withRouter(MoreMenuWrapper);



// WEBPACK FOOTER //
// ./src/mobileWrappers/MoreMenuWrapper/index.js